// src/layout/AdminLayout.jsx
import React from 'react'
import { Outlet } from 'react-router-dom'
import AdminCruds from '../components/Admin/AdminCruds'
import { Box } from '@mui/material'

const AdminLayout = () => {
  return (
    <Box sx={{ display: 'flex', height: '100vh' }}>
      {/* Sidebar */}
      <AdminCruds />

      {/* Contenido a la derecha del sidebar */}
      <Box sx={{ flex: 1, overflowY: 'auto', p: 3 }}>
        <Outlet />
      </Box>
    </Box>
  )
}

export default AdminLayout
